import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[appOldPasswordValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: OldPasswordValidatorDirective,
        multi: true
    }]
})
export class OldPasswordValidatorDirective implements Validator {
    @Input() appOldPasswordValidator : string;
    validate(c: AbstractControl): { [key: string]: any } | null {
        const Compare = c.parent.get(this.appOldPasswordValidator);
        if (Compare && Compare.value == c.value)
        {
            return { 'notEqual': true };
        }
        return null;
        
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/oldpwd-equal-validator.directive.ts